//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index";
import HiCell from "../../components/cell/Index.vue";
import PlanPricingPackage from "../../components/active/pricing_package/Index.vue";
import MemberDes from "../../components/team_member/des/Index.vue";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  DEVICE,
  PARAMS,
  CURRENT_USER_PLAN_LIST_SIMPLE,
} from "../../store/mutation-types";
import { list as planList } from "../../services/plans";

export default {
  name: "PaymentUpgradePage",
  components: { HiHeader, HiCell, PlanPricingPackage, HiButton, MemberDes },
  data() {
    const _this = this;
    return {
      demoPlan: [],
      /**
       * 无论何种情况都跳转到首页
       */
      overrideBackClick() {
        _this.$router.replace({ name: "MyPlanPage" });
      },
      hideBackBtn: false,
    };
  },
  methods: {
    /**
     * 跳转历史记录页面
     */
    paymentHistoryClick() {
      this.$router.push({ name: "PaymentHistoryPage" });
    },
    /**
     * 跳转支付账单页面
     */
    paymentBillingClick() {
      console.log("this.user.paymentMethod", this.user.paymentMethod);
      // 如果是paypal则进入无卡页面
      if (this.user.paymentMethod !== 2) {
        this.$router.push({ name: "PaymentBillingPage" });
      } else {
        this.$router.push({ name: "PaymentBillingPayPalPage" });
      }
    },
    backClick() {
      if (this.device === "android") {
        console.log("触发安卓关闭");
        // eslint-disable-next-line
        AndroidWebView.closeWebView(0); // 0 为未进行任何操作
        return;
      }
      // 如果url参数存在timestamp说明是通过app跳转，则直接跳转到my plan页面
      if (this.$router.query.timestamp) {
        this.$router.push({ name: "MyPlanPage" });
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      device: DEVICE,
      params: PARAMS,
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
    }),
    only() {
      let only = this.$route.query.only;
      if (only) {
        const activeIndex = this.planList.findIndex((i) => i.active);
        const currentPlanIndex = this.planList.findIndex(
          (p) => p.name.toLowerCase() === only.toLowerCase()
        );
        console.log({ activeIndex, currentPlanIndex });
        if (currentPlanIndex <= activeIndex) {
          only = "";
        }
      }
      return only;
    },
    priceFilter() {
      // 如果是续费页面则只显示高级和自己当前
      if (this.$route.query.type === "renew") {
        return true;
      }
      if (this.$route.query.type === "currentplan") {
        return true;
      }
      return this.$route.params.type === "filter";
    },
    queryType() {
      return this.$route.query.type;
    },
    /**
     * 计算标题栏文字
     */
    title() {
      if (this.$route.query.type === "renew") {
        return this.$t("planUpgradePage.renewPageTitle");
      } else {
        return this.$t("common.upgrade");
      }
    },
    /**
     * 是否全部可点击
     */
    allClick() {
      let allClickAble = false;
      // free2basicpromo 为显示非free样式 点击其他项为降级操作
      if (this.$route.query.type === "renew") {
        allClickAble = true;
      }
      return allClickAble;
    },
    /**
     * 类型
     */
    type() {
      return this.$route.query.type === "renew" ? "renew" : "normal";
    },
  },
  activated() {
    this.hideBackBtn = this.$route.query.back === "no";
    // 如果当前订阅的级别高于only的级别则显示全部plan
  },
  async created() {
    // 静默更新下plan
    this.demoPlan = await planList();
  },
  // watch: {
  //   async '$route'(to, from) {
  //     console.log(to, from)
  //     //   // 获取请求参数
  //     const params = to.query
  //     //   // 判断是否app跳转
  //     if (params.auth && to.name === 'PaymentUpgradePage') {
  //       console.log(this.params)
  //       const historyTimestamp = this.params ? this.params.timestamp : 0 // 上次打开时间戳
  //       const currentTimestamp = params.timestamp
  //       console.log(historyTimestamp, currentTimestamp)
  //       // 时间戳比较，如果相同说明不需要重新请求
  //       if (historyTimestamp !== currentTimestamp) {
  //         window.location.reload()
  //       }
  //     }
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/pages/payment/Upgrade.vue